import {
  Component,
  DoCheck,
  Input,
  OnInit,
  ViewEncapsulation
} from '@angular/core';

import { cloneDeep, defaults, isEqual } from 'lodash';

import { InfoStatusCardConfig } from './info-status-card-config';

/**
 * Info Status Card Component
 *
 * Usage:
 * <code><pre>
 * // Individual module import
 * import { InfoStatusCardModule } from 'patternfly-ng/card';
 * // Or
 * import { InfoStatusCardModule } from 'patternfly-ng';
 *
 * &#64;NgModule({
 *   imports: [InfoStatusCardModule,...]
 * })
 * export class AppModule(){}
 * </pre></code>
 *
 * Optional:
 * <code><pre>
 * import { InfoStatusCardConfig } from 'patternfly-ng/card';
 * </pre></code>
 */

export class InfoStatusCardComponent implements OnInit, DoCheck {

  /**
   * The config object containing component properties
   */
   config: InfoStatusCardConfig;

  private defaultConfig: InfoStatusCardConfig = {
    showTopBorder: false,
    htmlContent: true
  };

  private prevConfig: InfoStatusCardConfig;

  /**
   * The default constructor
   */
  constructor() {}

  /**
   * Setup component configuration upon initialization
   */
  ngOnInit(): void {
    this.setupConfig();
  }

  /**
   * Check if any component config props have changed
   */
  ngDoCheck(): void {
    if (!isEqual(this.config, this.prevConfig)) {
      this.setupConfig();
    }
  }

  /**
   * Set up default config
   */
  protected setupConfig(): void {

    if (this.config !== undefined) {
      defaults(this.config, this.defaultConfig);
    } else {
      this.config = cloneDeep(this.defaultConfig);
    }
    this.prevConfig = cloneDeep(this.config);
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  encapsulation: ViewEncapsulation.None,
  selector: 'pfng-info-status-card',
  template: `<div class="card-pf pfng-card-info-status" [class.card-pf-accented]="config.showTopBorder"><div class="pfng-card-info-image"><img *ngIf="config.iconImageSrc" src="{{config.iconImageSrc}}" alt="" class="info-img"> <span class="info-icon {{config.iconStyleClass}}"></span></div><div class="pfng-card-info-content"><h2 *ngIf="config.title" class="pfng-card-title"><a *ngIf="config.href" href="{{config.href}}"><span>{{config.title}}</span> </a><span *ngIf="!config.href"><span>{{config.title}}</span></span></h2><ng-container *ngIf="config.htmlContent !== undefined"><div *ngIf="config.htmlContent; then showHtmlContent else showPlainTextContent"></div><ng-template #showHtmlContent><div [innerHTML]="item" class="pfng-card-info-item" *ngFor="let item of config.info"></div></ng-template><ng-template #showPlainTextContent><div class="pfng-card-info-item" *ngFor="let item of config.info">{{item}}</div></ng-template></ng-container></div></div>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'config': [{ type: Input, args: ['config', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
